import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import customerManufacturersApi from "../shared/api/customerManufacturersApi";
import customerCategoriesApi from "../shared/api/customerCategoriesApi";
import { CustomerBuyerOffersState, OffersQuery, OffersQueryParameter } from "../shared/models/customerMyOffersModel";
import buyerOffersApi from "../shared/api/buyerOffersApi";
import buyerRfqsApi from "../myRfqs/api/buyerRfqsApi";


export const getOffers = createAsyncThunk(
  "customerReceivedOffers/getOffers",
  async (query: OffersQuery) => {
    return buyerOffersApi.getOffersAsync(query);
  }
);

export const getOffer = createAsyncThunk(
  "customerReceivedOffers/getOffer",
  async (id: string) => {
    return buyerOffersApi.getOffer(id);
  }
);

export const getRfq = createAsyncThunk(
  "customerReceivedOffers/getRfq",
  async (id: string) => {
    return buyerRfqsApi.getRfqAsync(id);
  }
);

export const seenOffer = createAsyncThunk(
  "customerReceivedOffers/seenOffer",
  async (id: string) => {
    return buyerOffersApi.seenOffer(id);
  }
);

export const declineOffer = createAsyncThunk(
  "customerReceivedOffers/declineOffer",
  async (id: string) => {
    return buyerOffersApi.declineOffer(id);
  }
);

export const getDocument = createAsyncThunk(
  "customerReceivedOffers/getDocument",
  async (id: string) => {
    return buyerOffersApi.getDocument(id);
  }
);

export const getManufacturers = createAsyncThunk(
  "customerReceivedOffers/getManufacturers",
  async () => {
    return customerManufacturersApi.getManufacturers();
  }
);

export const getCategories = createAsyncThunk(
  "customerReceivedOffers/getCategories",
  async () => {
    return customerCategoriesApi.getCategories();
  }
);

const initialState: CustomerBuyerOffersState = {
  query: {
    search: undefined,
    sortBy: OffersQueryParameter.createdDate,
    quotationRequestId: undefined,
    sortDesc: true,
    pageNo: 1,
    pageSize: 20
  },
  rfq: undefined,
  offers: undefined,
  offer: undefined,
  manufacturers: [],
  categories: [],
  loading: false,
  success: undefined,
  error: undefined
};

const customerReceivedOffersSlice = createSlice({
  name: "customerReceivedOffers",
  initialState: initialState,
  reducers: {
    changeQuery: (state, action) => {
      state.query = action.payload;
    },
    selectOffer: (state, { payload }) => {
      state.offer = payload;
    },
    setLoading: (state, { payload }) => {
      state.loading = payload;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(getOffers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOffers.fulfilled, (state, { payload }) => {
        state.offers = payload;
        state.loading = false;
      })
      .addCase(getOffers.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      });

    builder
      .addCase(getOffer.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOffer.fulfilled, (state, { payload }) => {
        state.offer = payload;
        state.loading = false;
      })
      .addCase(getOffer.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      });

    builder
      .addCase(getRfq.fulfilled, (state, { payload }) => {
        state.rfq = payload;
        state.loading = false;
      })

    builder
      .addCase(getDocument.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDocument.fulfilled, (state, { payload }) => {
        state.loading = false;
      })
      .addCase(getDocument.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      });

    builder
      .addCase(getManufacturers.fulfilled, (state, { payload }) => {
        state.manufacturers = payload;
      });

    builder
      .addCase(getCategories.fulfilled, (state, { payload }) => {
        state.categories = payload;
      });
  }
});

export const {
  changeQuery,
  selectOffer,
  setLoading,
  setSuccess,
  setError
} = customerReceivedOffersSlice.actions;

export default customerReceivedOffersSlice.reducer;